import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {NGXLogger} from 'ngx-logger';
import {Subscription} from 'rxjs';
import {AssetTypeService} from '../../../../_services/asset-type-service';


@Component({
  selector: 'acabim-admin-add-asset-type',
  templateUrl: './add-asset-type.component.html',
  styleUrls: ['./add-asset-type.component.scss']
})
export class AddAssetTypeComponent implements OnInit, OnDestroy {
  @Output() completed = new EventEmitter<string>();
  public loading = false;
  public assetTypeForm: FormGroup | null = null;
  private _currentProcess: Subscription = new Subscription();

  constructor(
      private readonly logger: NGXLogger,
      private readonly assetTypeService: AssetTypeService
  ) {
    this.loading = true;
  }

  ngOnInit(): void {
    this.initForm();
  }

  ngOnDestroy():void {
    this._currentProcess.unsubscribe();
  }

  private initForm(): void {
    this.assetTypeForm = new FormGroup({
      name: new FormControl(null, Validators.required),
      description: new FormControl(null)
    });
    this.loading = false;
  }

  onSubmit(): void {
    this.loading = true;
    if (this.assetTypeForm && this.assetTypeForm.value) {
      this.upsertContactType();
    }
  }

  onCancel(): void {
    this.completed.emit('cancelled');
  }

  private upsertContactType(): void {
    if (this.assetTypeForm && this.assetTypeForm.value) {
      this.logger.debug('[AssetTypeAddComponent] Adding new asset type');
      this._currentProcess = this.assetTypeService.upsertAssetType(
          this.assetTypeForm.value.name,
          this.assetTypeForm.value.description
      ).subscribe(newAssetType => {
        this.logger.debug('[AssetTypeAddComponent] Asset type added successfully: ', newAssetType.id);
        this.initForm();
        this.completed.emit('added');
        this.loading = false;
        console.log('Upsert: added');
      }, (error: any) => {
        this.logger.debug('[AssetTypeAddComponent] Asset type failed to add');
        this.logger.error(error);
        this.loading = false;
      });
    }
  }
}
